import React, { useRef, useState } from 'react';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import { Formik, Field, FormikProps } from 'formik';
import * as Bixby from '$/core';
import { AppState } from '$/store';
import Modal from '$/components/global/modal';
import InputBlock from '$/components/global/inputBlock';
import BixButton from '$/components/global/bixButton';
import PeopleSearchBox from '$/components/global/peopleSearchBox';
import './CreateClientCompanyTask.scss';
import { addPublicCompanyTask } from '$/store/company/actions';

export interface ICreatePublicCompanyTaskProps {
  isAddingPublicCompanyTask?: boolean;
  currentCompany?: Bixby.Models.AdminCompany;
  onCloseModal: () => void;
  dispatchAddPublicCompanyTask: (newCompany: Bixby.Models.CreatePublicCompanyTask) => Promise<void>;
}

export interface CreatePublicCompanyTaskValues {
  timeFromEmail: string;
  companyName: string;
  bixbyId: string;
  isEmailOnly: boolean;
}

const CreatePublicCompanyTask: React.FC<ICreatePublicCompanyTaskProps> = props => {
  const { isAddingPublicCompanyTask, currentCompany, onCloseModal, dispatchAddPublicCompanyTask } = props;
  const [assignees, setAssignees] = useState<string[]>([]);

  const initialNewTask: CreatePublicCompanyTaskValues = {
    timeFromEmail: dayjs(new Date()).format('ddd MM/DD/YYYY h:mm a').toString(),
    companyName: currentCompany?.name ?? '',
    bixbyId: currentCompany?.bixbyId ?? '',
    isEmailOnly: false,
  };

  const formikRef = useRef<FormikProps<CreatePublicCompanyTaskValues>>(null);

  const handleCloseModal = () => {
    if (formikRef && formikRef.current) {
      formikRef.current.resetForm();
    }

    setAssignees([]);

    onCloseModal();
  };

  const createTaskForm = (
    <Modal title="Assign Email Task" forForm onClose={handleCloseModal} active={true}>
      <div>
        <Formik
          innerRef={formikRef}
          initialValues={initialNewTask}
          onSubmit={async (values: CreatePublicCompanyTaskValues) => {
            const newTask: Bixby.Models.CreatePublicCompanyTask = {
              ...values,
              assignees: assignees,
            };
            await dispatchAddPublicCompanyTask(newTask);
            handleCloseModal();
          }}
          render={({ handleSubmit }) => (
            <form className="create-task-form" onSubmit={handleSubmit}>
              <div className="profile-input-container">
                <div>
                  <InputBlock title="Time (from Email)">
                    <Field type="text" name="timeFromEmail" />
                  </InputBlock>
                  <InputBlock title="Company Name">
                    <input type="text" value={initialNewTask.companyName} disabled />
                  </InputBlock>
                  <InputBlock title="BixbyID">
                    <input type="text" value={initialNewTask.bixbyId} disabled />
                  </InputBlock>
                  <hr />
                </div>
                <hr />
                <PeopleSearchBox
                  title="Assign Task"
                  showMnpiUsers={false}
                  onChange={(ids: string[]) => setAssignees(ids)}
                />
              </div>
              <BixButton
                useSmall
                type="submit"
                disabled={isAddingPublicCompanyTask}
                useLoading
                isLoading={isAddingPublicCompanyTask}>
                Allocate Task
              </BixButton>
            </form>
          )}></Formik>
      </div>
    </Modal>
  );

  if (!currentCompany) {
    return null;
  }
  return <div>{createTaskForm}</div>;
};

const mapStateToProps = (state: AppState) => {
  return {
    companyIsLoading: state.companyState.isLoading,
    error: state.companyState.error,
    currentCompany: state.companyState.currentCompany,
    isAddingPublicCompanyTask: state.companyState.isAddingPublicCompanyTask,
    dataSiteProviders: state.dataSiteProviderState.data,
    dataSiteTypes: state.dataSiteTypeState.data,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchAddPublicCompanyTask: (model: Bixby.Models.CreatePublicCompanyTask) => dispatch(addPublicCompanyTask(model)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreatePublicCompanyTask);
